import React, { forwardRef, type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import { Trigger as RadixTrigger } from "@radix-ui/react-dialog";

export type ModalTriggerProps = Omit<BaseProps<"button">, "children"> & {
  children: ReactNode;
};

export const ModalTrigger = forwardRef<HTMLButtonElement, ModalTriggerProps>(
  ({ children, ...props }, ref) => {
    return (
      <RadixTrigger asChild ref={ref} {...props}>
        {children}
      </RadixTrigger>
    );
  }
);
